import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["css", "as", "asChild", "style", "className", "value", "name", "id", "placeholder", "disabled", "onChange", "hasError", "resize", "minRows", "maxRows"];
import React, { useImperativeHandle, useLayoutEffect, useRef } from "react";
import { manualResize, smartResize } from "./logic";
import { BaseTextarea } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
var Textarea = /*#__PURE__*/React.forwardRef(function (_ref, forwardedRef) {
  var css = _ref.css,
    as = _ref.as,
    asChild = _ref.asChild,
    style = _ref.style,
    className = _ref.className,
    value = _ref.value,
    name = _ref.name,
    id = _ref.id,
    placeholder = _ref.placeholder,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    hasError = _ref.hasError,
    _ref$resize = _ref.resize,
    resize = _ref$resize === void 0 ? "smart" : _ref$resize,
    _ref$minRows = _ref.minRows,
    minRows = _ref$minRows === void 0 ? 4 : _ref$minRows,
    _ref$maxRows = _ref.maxRows,
    maxRows = _ref$maxRows === void 0 ? 20 : _ref$maxRows,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var textareaRef = useRef(null);
  useImperativeHandle(forwardedRef, function () {
    return textareaRef.current;
  });
  /**
   * As user input changes, perform smart resizing
   */
  useLayoutEffect(function () {
    if (resize === "smart") {
      smartResize({
        textareaRef: textareaRef,
        minRows: minRows,
        maxRows: maxRows
      });
    }
  }, [textareaRef, minRows, maxRows, resize, value]);

  /**
   * For all non-smart resizing, adjust the textarea manually
   */
  useLayoutEffect(function () {
    if (resize !== "smart") {
      manualResize({
        textareaRef: textareaRef,
        minRows: minRows,
        maxRows: maxRows
      });
    }
  }, [textareaRef, minRows, maxRows, resize]);
  return /*#__PURE__*/_jsx(BaseTextarea, _extends({
    value: value,
    name: name,
    ref: textareaRef,
    disabled: disabled,
    id: id,
    resize: resize,
    placeholder: placeholder,
    onChange: onChange,
    hasError: hasError,
    "aria-disabled": disabled,
    "aria-labelledby": name
  }, restProps));
});
Textarea.displayName = "Textarea";
export default Textarea;